
import BaseModel from './BaseModel';

export default class Product extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.description = data.description || this.translate.description || undefined;
    }

    export(hasTranslate=false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            description: this.description,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                voucherProductId: this.translate.voucherProductId || this.id,
                name: this.name,
                description: this.description,
                languageCode: this.languageCode,
            }
        }
        return result;
    }
}